// libraries
import React, { useEffect, useState } from 'react'
// components
import Icon from '@/components/UI/Icon/Icon'
import Modal from '@/components/UI/Modal/Modal'
// services
import {ToastService} from "@/components/ToastProvider/ToastProvider";
// types
import {TOAST_ICONS, ToastType} from "@/types/toast";
// styles
import styles from './Toast.module.scss'

type Props = {
  toast: ToastType
}

const Toast: React.FC<Props> = ({ toast }: Props) => {
  const [offScreen, setOffScreen] = useState(true)
  const [modalOpen, setModalOpen] = useState(false)

  const removeToast = () => {
    setOffScreen(true)
    setTimeout(() => ToastService.delete(toast.id), 500)
  }

  useEffect(() => {
    setTimeout(() => setOffScreen(false), 25)
  }, [])

  useEffect(() => {
    if (toast.type === 'success')
      setTimeout(() => removeToast(), toast.duration || 3000)
  }, [offScreen])

  const Body = toast.body

  let message: string | null = toast.text

  try {
    // @ts-expect-error unknown message structure, handled below
    const parsedText = JSON.parse(message)
    if (parsedText.detail) message = parsedText.detail
    if (parsedText.detail && parsedText.statusCode === 429)
      message = formatThrottleMessage(parsedText.detail)
    if (parsedText.message) message = parsedText.message
    if (parsedText.errors) message = parsedText.errors
  } catch {
    message = toast.text
  }

  return (
    <div
      className={`${styles.outerContainer} ${offScreen ? styles.outerOffscreen : ''}`}
    >
      <div
        className={`${styles.toastContainer} ${styles[toast.type]} ${offScreen ? styles.offscreen : ''}`}
      >
        <Icon icon={TOAST_ICONS[toast.type]} />
        {(toast.title || message) && (
          <div className={styles.centerContainer}>
            <h4 className={styles.title}>{toast.title}</h4>
            <div className={styles.text}>{message}</div>
            {toast.type !== 'success' && (
              <>
                <button
                  className={styles.viewButton}
                  onClick={() => setModalOpen(true)}
                >
                  View
                </button>
                <Modal
                  open={modalOpen}
                  onClose={() => setModalOpen(false)}
                  header={toast.title}
                  size='small'
                  closeIcon
                >
                  {toast.text}
                </Modal>
              </>
            )}
          </div>
        )}

        {!!Body && <Body id={toast.id} />}

        <button className={styles.removeButton} onClick={removeToast}>
          <Icon icon='xmark' />
        </button>
      </div>
    </div>
  )
}

export default Toast

const formatThrottleMessage = (message: string) => {
  const secondsRemain = message.replace(/\D/g, '')

  return 'Request throttled. Available in ' + secondsRemain + ' seconds.'
}
